import styled from 'styled-components';
import React from 'react';
import PropTypes from '@userzoomlibraries/toolkit-js-utils/prop-types';
import { jsx } from 'react/jsx-runtime';

/**
 * @license
 * This source code is and remains the property of UserZoom Technologies Inc (sucursal en España).
 * Dissemination of this information or reproduction of this material is strictly
 * forbidden unless prior written permission is obtained from
 * UserZoom Technologies Inc (sucursal en España) (https://www.userzoom.com).
 */
var Trigger$1 = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var className = _ref.className,
      children = _ref.children;
  return /*#__PURE__*/jsx("div", {
    className: "gz-relative-dialog__trigger ".concat(className),
    children: /*#__PURE__*/React.cloneElement(children, {
      ref: ref
    })
  });
});
Trigger$1.COMPONENT_ID = 'Gearz.RelativeDialog.Trigger';
Trigger$1.displayName = Trigger$1.COMPONENT_ID;
Trigger$1.propTypes = {
  className: PropTypes.stringWithDescription('Custom class to be applied.'),
  children: PropTypes.oneOfTypeWithDescription([PropTypes.node, PropTypes.func], 'Content of the trigger element.')
};
Trigger$1.defaultProps = {
  className: '',
  children: null
};

/**
 * @license
 * This source code is and remains the property of UserZoom Technologies Inc (sucursal en España).
 * Dissemination of this information or reproduction of this material is strictly
 * forbidden unless prior written permission is obtained from
 * UserZoom Technologies Inc (sucursal en España) (https://www.userzoom.com).
 */
var Trigger = styled(Trigger$1).withConfig({
  componentId: "gz-dialog-1674727614741__sc-qpgtfi-0"
})(["-webkit-tap-highlight-color:transparent;display:inline-block;position:relative;user-select:none;"]);
Trigger.displayName = Trigger$1.displayName;
Trigger.propTypes = Trigger$1.propTypes;
Trigger.defaultProps = Trigger$1.defaultProps;

export { Trigger as T };
